// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/search_accounts.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { WorkFunction } from "../general/work_function_pb";
import { file_general_work_function } from "../general/work_function_pb";
import type { WorkDepartment } from "../general/work_department_pb";
import { file_general_work_department } from "../general/work_department_pb";
import type { WorkLocation } from "../general/work_location_pb";
import { file_general_work_location } from "../general/work_location_pb";
import type { EyeColor } from "../general/eye_color_pb";
import { file_general_eye_color } from "../general/eye_color_pb";
import type { HairColor } from "../general/hair_color_pb";
import { file_general_hair_color } from "../general/hair_color_pb";
import type { Gender } from "../general/gender_pb";
import { file_general_gender } from "../general/gender_pb";
import type { Ethnicity } from "../general/ethnicity_pb";
import { file_general_ethnicity } from "../general/ethnicity_pb";
import type { SpokenLanguage } from "../general/spoken_language_pb";
import { file_general_spoken_language } from "../general/spoken_language_pb";
import type { SearchQueryLanguage } from "../general/search_query_language_pb";
import { file_general_search_query_language } from "../general/search_query_language_pb";
import type { ProfileCover } from "./profile_cover_pb";
import { file_accounts_profile_cover } from "./profile_cover_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/search_accounts.proto.
 */
export const file_accounts_search_accounts: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_wrappers, file_general_work_function, file_general_work_department, file_general_work_location, file_general_eye_color, file_general_hair_color, file_general_gender, file_general_ethnicity, file_general_spoken_language, file_general_search_query_language, file_accounts_profile_cover]);

/**
 * @generated from message protos.accounts.SearchAccountsRequest
 */
export type SearchAccountsRequest = Message<"protos.accounts.SearchAccountsRequest"> & {
  /**
   * @generated from field: protos.accounts.SearchAccountsRequest.Params params = 1;
   */
  params?: SearchAccountsRequest_Params | undefined;

  /**
   * @generated from field: protos.accounts.SearchAccountsRequest.Pagination pagination = 2;
   */
  pagination?: SearchAccountsRequest_Pagination | undefined;
};

/**
 * Describes the message protos.accounts.SearchAccountsRequest.
 * Use `create(SearchAccountsRequestSchema)` to create a new message.
 */
export const SearchAccountsRequestSchema: GenMessage<SearchAccountsRequest> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts, 0);

/**
 * @generated from message protos.accounts.SearchAccountsRequest.Params
 */
export type SearchAccountsRequest_Params = Message<"protos.accounts.SearchAccountsRequest.Params"> & {
  /**
   * @generated from field: string search_query = 1;
   */
  searchQuery: string;

  /**
   * @generated from field: repeated protos.general.WorkFunction work_functions = 2;
   */
  workFunctions: WorkFunction[];

  /**
   * @generated from field: int32 on_screen_age_start = 3;
   */
  onScreenAgeStart: number;

  /**
   * @generated from field: int32 on_screen_age_end = 4;
   */
  onScreenAgeEnd: number;

  /**
   * @generated from field: repeated protos.general.EyeColor eye_colors = 5;
   */
  eyeColors: EyeColor[];

  /**
   * @generated from field: repeated protos.general.HairColor hair_colors = 6;
   */
  hairColors: HairColor[];

  /**
   * @generated from field: repeated protos.general.Gender genders = 7;
   */
  genders: Gender[];

  /**
   * @generated from field: repeated protos.general.Ethnicity ethnicities = 8;
   */
  ethnicities: Ethnicity[];

  /**
   * @generated from field: repeated protos.general.SpokenLanguage spoken_languages = 9;
   */
  spokenLanguages: SpokenLanguage[];

  /**
   * @generated from field: repeated protos.general.WorkLocation work_locations = 10;
   */
  workLocations: WorkLocation[];

  /**
   * @generated from field: protos.general.SearchQueryLanguage search_query_language = 11;
   */
  searchQueryLanguage: SearchQueryLanguage;

  /**
   * @generated from field: bool include_union_memberships = 12;
   */
  includeUnionMemberships: boolean;

  /**
   * @generated from field: google.protobuf.BoolValue has_union = 13;
   */
  hasUnion?: boolean | undefined;
};

/**
 * Describes the message protos.accounts.SearchAccountsRequest.Params.
 * Use `create(SearchAccountsRequest_ParamsSchema)` to create a new message.
 */
export const SearchAccountsRequest_ParamsSchema: GenMessage<SearchAccountsRequest_Params> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts, 0, 0);

/**
 * @generated from message protos.accounts.SearchAccountsRequest.Pagination
 */
export type SearchAccountsRequest_Pagination = Message<"protos.accounts.SearchAccountsRequest.Pagination"> & {
  /**
   * @generated from field: string page_token = 1;
   */
  pageToken: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;
};

/**
 * Describes the message protos.accounts.SearchAccountsRequest.Pagination.
 * Use `create(SearchAccountsRequest_PaginationSchema)` to create a new message.
 */
export const SearchAccountsRequest_PaginationSchema: GenMessage<SearchAccountsRequest_Pagination> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts, 0, 1);

/**
 * @generated from message protos.accounts.SearchAccountsResponse
 */
export type SearchAccountsResponse = Message<"protos.accounts.SearchAccountsResponse"> & {
  /**
   * @generated from field: protos.accounts.SearchAccountsResponse.Result result = 1;
   */
  result?: SearchAccountsResponse_Result | undefined;

  /**
   * @generated from field: protos.accounts.SearchAccountsResponse.Pagination pagination = 2;
   */
  pagination?: SearchAccountsResponse_Pagination | undefined;
};

/**
 * Describes the message protos.accounts.SearchAccountsResponse.
 * Use `create(SearchAccountsResponseSchema)` to create a new message.
 */
export const SearchAccountsResponseSchema: GenMessage<SearchAccountsResponse> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts, 1);

/**
 * @generated from message protos.accounts.SearchAccountsResponse.Result
 */
export type SearchAccountsResponse_Result = Message<"protos.accounts.SearchAccountsResponse.Result"> & {
  /**
   * @generated from field: repeated protos.accounts.SearchAccountsResponse.Result.Account accounts = 1;
   */
  accounts: SearchAccountsResponse_Result_Account[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message protos.accounts.SearchAccountsResponse.Result.
 * Use `create(SearchAccountsResponse_ResultSchema)` to create a new message.
 */
export const SearchAccountsResponse_ResultSchema: GenMessage<SearchAccountsResponse_Result> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts, 1, 0);

/**
 * @generated from message protos.accounts.SearchAccountsResponse.Result.Account
 */
export type SearchAccountsResponse_Result_Account = Message<"protos.accounts.SearchAccountsResponse.Result.Account"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string pfp_url = 3;
   */
  pfpUrl: string;

  /**
   * @generated from field: protos.accounts.SearchAccountsResponse.Result.Account.WorkFunctionData main_work_function = 4;
   */
  mainWorkFunction?: SearchAccountsResponse_Result_Account_WorkFunctionData | undefined;

  /**
   * @generated from field: repeated protos.accounts.ProfileCover covers = 5;
   */
  covers: ProfileCover[];

  /**
   * @generated from field: protos.general.WorkLocation main_work_location = 6;
   */
  mainWorkLocation: WorkLocation;

  /**
   * @generated from field: repeated protos.accounts.SearchAccountsResponse.Result.Account.WorkFunctionData other_work_functions = 7;
   */
  otherWorkFunctions: SearchAccountsResponse_Result_Account_WorkFunctionData[];

  /**
   * @generated from field: repeated protos.accounts.SearchAccountsResponse.Result.Account.UnionMembership union_memberships = 8;
   */
  unionMemberships: SearchAccountsResponse_Result_Account_UnionMembership[];
};

/**
 * Describes the message protos.accounts.SearchAccountsResponse.Result.Account.
 * Use `create(SearchAccountsResponse_Result_AccountSchema)` to create a new message.
 */
export const SearchAccountsResponse_Result_AccountSchema: GenMessage<SearchAccountsResponse_Result_Account> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts, 1, 0, 0);

/**
 * @generated from message protos.accounts.SearchAccountsResponse.Result.Account.WorkFunctionData
 */
export type SearchAccountsResponse_Result_Account_WorkFunctionData = Message<"protos.accounts.SearchAccountsResponse.Result.Account.WorkFunctionData"> & {
  /**
   * @generated from field: protos.general.WorkFunction function = 1;
   */
  function: WorkFunction;

  /**
   * @generated from field: protos.general.WorkDepartment department = 2;
   */
  department: WorkDepartment;
};

/**
 * Describes the message protos.accounts.SearchAccountsResponse.Result.Account.WorkFunctionData.
 * Use `create(SearchAccountsResponse_Result_Account_WorkFunctionDataSchema)` to create a new message.
 */
export const SearchAccountsResponse_Result_Account_WorkFunctionDataSchema: GenMessage<SearchAccountsResponse_Result_Account_WorkFunctionData> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts, 1, 0, 0, 0);

/**
 * @generated from message protos.accounts.SearchAccountsResponse.Result.Account.UnionMembership
 */
export type SearchAccountsResponse_Result_Account_UnionMembership = Message<"protos.accounts.SearchAccountsResponse.Result.Account.UnionMembership"> & {
  /**
   * @generated from field: string union_id = 1;
   */
  unionId: string;

  /**
   * @generated from field: repeated protos.accounts.SearchAccountsResponse.Result.Account.UnionMembership.CertifiedFunction certified_functions = 2;
   */
  certifiedFunctions: SearchAccountsResponse_Result_Account_UnionMembership_CertifiedFunction[];
};

/**
 * Describes the message protos.accounts.SearchAccountsResponse.Result.Account.UnionMembership.
 * Use `create(SearchAccountsResponse_Result_Account_UnionMembershipSchema)` to create a new message.
 */
export const SearchAccountsResponse_Result_Account_UnionMembershipSchema: GenMessage<SearchAccountsResponse_Result_Account_UnionMembership> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts, 1, 0, 0, 1);

/**
 * @generated from message protos.accounts.SearchAccountsResponse.Result.Account.UnionMembership.CertifiedFunction
 */
export type SearchAccountsResponse_Result_Account_UnionMembership_CertifiedFunction = Message<"protos.accounts.SearchAccountsResponse.Result.Account.UnionMembership.CertifiedFunction"> & {
  /**
   * @generated from field: protos.general.WorkFunction function = 1;
   */
  function: WorkFunction;
};

/**
 * Describes the message protos.accounts.SearchAccountsResponse.Result.Account.UnionMembership.CertifiedFunction.
 * Use `create(SearchAccountsResponse_Result_Account_UnionMembership_CertifiedFunctionSchema)` to create a new message.
 */
export const SearchAccountsResponse_Result_Account_UnionMembership_CertifiedFunctionSchema: GenMessage<SearchAccountsResponse_Result_Account_UnionMembership_CertifiedFunction> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts, 1, 0, 0, 1, 0);

/**
 * @generated from message protos.accounts.SearchAccountsResponse.Pagination
 */
export type SearchAccountsResponse_Pagination = Message<"protos.accounts.SearchAccountsResponse.Pagination"> & {
  /**
   * @generated from field: string next_page_token = 1;
   */
  nextPageToken: string;
};

/**
 * Describes the message protos.accounts.SearchAccountsResponse.Pagination.
 * Use `create(SearchAccountsResponse_PaginationSchema)` to create a new message.
 */
export const SearchAccountsResponse_PaginationSchema: GenMessage<SearchAccountsResponse_Pagination> = /*@__PURE__*/
  messageDesc(file_accounts_search_accounts, 1, 1);

